import angular from 'angular'

import dispatchCtrl from './dispatch.controller'
import dispatchRoutes from './dispatch.routes'
import dispatchRun from './dispatch.run'

const name = 'routingConsultDispatch'

angular.module(name, [])
  .controller('dispatchCtrl', dispatchCtrl)
  .config(dispatchRoutes)
  .run(dispatchRun)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/dispatch/dispatch.module.js